import axios from 'axios';
import { SOURCE } from './config';
export const getStaticBaseUrl = () => {
  if (window.feConfig && window.feConfig.common && window.feConfig.common.staticBaseUrl) {
    return window.feConfig.common.staticBaseUrl;
  }
  return 'https://stc.yxt.com/';
};

const axiosInstance = axios.create({
  timeout: 30000
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.token = localStorage.getItem('token');
    config.headers.source = SOURCE;
    return config;
  },
  (error) => {
    console.log('🔥 request err', error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.log('🔥 response err', error);
    const statusCode = error.response.status;
    if (statusCode === 401) {
      // ssoLogin()
      return;
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;

